import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import VideosContent from "components/company/v3/contents/highlights/VideosContent";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import { CompanyHighlightsTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import { YoutubeIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface AmericanHighlightsBoxProps {
  tab: CompanyHighlightsTabEnum;
  onChangeTab: (tab: CompanyHighlightsTabEnum) => void;
}

export default function AmericanHighlightsBox({ tab, onChangeTab }: AmericanHighlightsBoxProps) {
  const intl = useIntl();
  const { youtubeVideos } = useAmericanIssuer();

  return (
    <CompanyContainer className="xl:h-full">
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyHighlightsTabEnum.VIDEOS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyHighlightsTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            tabs={[
              {
                value: CompanyHighlightsTabEnum.VIDEOS,
                label: intl.formatMessage({
                  defaultMessage: "Vídeo",
                  description: "Aba do menu superior da empresa",
                  id: 'vjkGXg',
                }),
                icon: <YoutubeIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />
          <CompanyTabsContent value={CompanyHighlightsTabEnum.VIDEOS}>
            <VideosContent youtubeVideos={youtubeVideos} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
